/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import {
  setRawCookie, setCookie, getRawCookie, removeCookie, isCookieEnabled,
} from '@/services/helpers/cookie';

import { authentication, refresh as _refresh } from '@/services/api/oauth2/oauth';

const DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN;
const { CancelToken } = axios;

let cancel;
const defaultOptions = {
  baseURL: `${import.meta.env.VITE_API_BASEURL}v1/`,
  cancelToken: new CancelToken(((c) => {
    cancel = c;
  })),
};
const instance = Object.assign(axios.create(defaultOptions), { cancel });

// helpers for api
// eslint-disable-next-line camelcase
instance.setToken = (key, access_token, refresh_token, options) => {
  // eslint-disable-next-line camelcase
  if (isCookieEnabled) {
    setCookie(key, { access_token, refresh_token }, options);
  }
};

instance.setAuthorization = (accessToken) => {
  const token = accessToken || (isCookieEnabled ? getRawCookie('access_token') : null);
  if (token) {
    instance.defaults.headers.common
      .Authorization = `Bearer ${token}`;
  } else {
    delete instance.defaults.headers.common.Authorization;
  }
  return Promise.resolve();
};

instance.initialize = async () => {
  const res = await authentication();
  if (res && res.status === 200) {
    instance.defaults.headers.common
      .Authorization = `Bearer ${res.data.access_token}`;
  }
  return res;
};

// Function for interceptors

const authenticate = async (error) => {
  if (!error._retry) {
    const res = await authentication();
    if (res && res.status === 200) {
      const bearer = `Bearer ${res.data.access_token}`;
      instance.defaults.headers.common.Authorization = bearer;
      Object.assign(error.headers, { Authorization: bearer });
      return instance(Object.assign(error, { _retry: true }));
    }
  }
  return Promise.reject(error);
};

const refresh = async (error, refreshToken) => {
  if (!error._retry) {
    try {
      const res = await _refresh(refreshToken);
      if (res && res.status === 200) {
        const bearer = `Bearer ${res.data.access_token}`;
        setRawCookie('access_token', res.data.access_token, { expires: 30, domain: DOMAIN });
        setRawCookie('refresh_token', res.data.refresh_token, { expires: 30, domain: DOMAIN });
        instance.defaults.headers.common.Authorization = bearer;
        Object.assign(error.headers, { Authorization: bearer });
        return instance(Object.assign(error, { _retry: true }));
      }
    } catch (err) {
      console.error(err);
      removeCookie('access_token', { domain: DOMAIN });
      removeCookie('refresh_token', { domain: DOMAIN });
    }
  }
  return Promise.reject(error);
};

instance.interceptors.response.use((response) => response, (error) => {
  const { config, response } = error;
  if (response && response.status === 401 && !config._retry) {
    const refreshToken = getRawCookie('refresh_token');
    if (!refreshToken) {
      return authenticate(config);
    }
    return refresh(config, refreshToken);
  }
  return Promise.reject(error);
});
const api = () => instance;
export default api;
